import React, { useEffect, useState } from "react";
import { apiNomenclature } from "api/nomenclature.service";
import TextInput from "components/inputs/TextInput";
import CustomSelect from "components/inputs/CustomSelect";

export default function SectionDateDeContact({ formik, consumer_type, tenant_assoc, isUsedInOpenTicketModal }) {
   const [optionsBanks, setOptionsBanks] = useState([]);

   useEffect(() => {
      const getOptionsBanks = async () => {
         const response = await apiNomenclature.getBanks();
         setOptionsBanks(
            response.data.map(item => {
               return { value: item.company_bank_id, label: item.company_bank };
            }),
         );
      };

      getOptionsBanks();
   }, []);

   return (
      <>
         <h2 className="custom-label-title">Date de contact</h2>
         <div className="row mb-25">
            <TextInput
               name={"email"}
               label={"Email"}
               value={formik.values.email}
               error={formik.errors.email}
               touched={formik.touched.email}
               isDisabled={isUsedInOpenTicketModal}
               setFieldValue={formik.setFieldValue}
               parentClassName={"col-md-6 input-row"}
            />
            <TextInput
               name={"phone_number"}
               label={"Telefon"}
               value={formik.values.phone_number}
               error={formik.errors.phone_number}
               touched={formik.touched.phone_number}
               setFieldValue={formik.setFieldValue}
               parentClassName={"col-md-6"}
               isDisabled={isUsedInOpenTicketModal}
            />
         </div>
         {(consumer_type === "pj" || tenant_assoc === "1") && (
            <>
               <div className="row mb-25">
                  <TextInput
                     name={"company_name"}
                     label={"Nume firma"}
                     value={formik.values.company_name}
                     error={formik.errors.company_name}
                     touched={formik.touched.company_name}
                     setFieldValue={formik.setFieldValue}
                     parentClassName={"col-md-6 input-row"}
                     isDisabled={isUsedInOpenTicketModal}
                  />
                  <div className="col-md-6">
                     <div className="checkbox-wrapper-13 d-flex align-items-center mb-2">
                        <input
                           className="checkbox-input"
                           type="checkbox"
                           name="company_fiscal_attribute"
                           id="company_fiscal_attribute"
                           checked={formik.values.company_fiscal_attribute === "RO"}
                           onChange={e => formik.setFieldValue("company_fiscal_attribute", e.target.checked ? "RO" : "-")}
                        />
                        <label htmlFor="company_fiscal_attribute" className="ms-2 checkbox-label">
                           Platitor de TVA
                        </label>
                     </div>
                     <div className={`cui-input-wrapper ${formik.errors.company_cif && formik.touched.company_cif ? "cui-input-error" : ""}`}>
                        {formik.values.company_fiscal_attribute === "RO" && <span className="cui-input-prefix">RO</span>}
                          <div className="text-input-wrapper cui-input-inner">
                           <input
                              autoComplete="off"
                              className="cui-input-field"
                              type="text"
                              inputMode="numeric"
                              disabled={isUsedInOpenTicketModal}
                              id="company_cif"
                              name="company_cif"
                              placeholder="CUI/CIF"
                              value={formik.values.company_cif}
                              onChange={e => {
                                 const val = e.target.value.replace(/\D/g, "");
                                 formik.setFieldValue("company_cif", val);
                              }}
                              onKeyDown={e => {
                                 if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                                    e.preventDefault();
                                 }
                              }}
                           />
                           <label className="text-input-label" htmlFor="company_cif">
                              CUI/CIF
                           </label>
                        </div>
                     </div>
                     {formik.errors.company_cif && formik.touched.company_cif && <p className="error-msg">{formik.errors.company_cif}</p>}
                  </div>
               </div>
               {!isUsedInOpenTicketModal && (
                  <div className="row mb-25">
                     <TextInput
                        name={"company_bank_account"}
                        label={"Cont bancar"}
                        value={formik.values.company_bank_account}
                        error={formik.errors.company_bank_account}
                        touched={formik.touched.company_bank_account}
                        setFieldValue={formik.setFieldValue}
                        parentClassName={"col-md-6 input-row"}
                        isDisabled={isUsedInOpenTicketModal}
                     />
                     <CustomSelect
                        options={optionsBanks}
                        value={formik.values.company_bank_id}
                        onChange={value => formik.setFieldValue("company_bank_id", value.value)}
                        placeholder="Alege banca..."
                        name={"company_bank_id"}
                        label={"Banca"}
                        error={formik.errors.company_bank_id}
                        touched={formik.touched.company_bank_id}
                        parentClassName={"col-md-6 relative input-row"}
                        labelClassName={"label-select"}
                     />
                  </div>
               )}
            </>
         )}
      </>
   );
}
